export default {
  // baseUrl: "https://naf-api.viserx.net/api",
  "baseUrl": 'http://nafappapi.viserx.net/api',
  // baseUrl: "https://naf-api.viserx.net/api", //main domain
}; 